import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  EditButton,
  DateField,
  SaveButton,
  Toolbar,
  TabbedForm,
  FormTab,
  NumberInput,
  NumberField,
  UrlField,
  LongTextInput,
  SelectInput
} from 'react-admin';

const required = (message = 'Required') =>
  value => value ? undefined : message;

export const BlockerList = (props) => (
  <List {...props} title="List of Blockers" bulkActionButtons={false}>
    <Datagrid>
      <DateField source="created_at" showTime/>
      <TextField source="title"/>
      <TextField source="sub_title"/>
      <TextField source="link_name"/>
      <UrlField source="link_url"/>
      <NumberField source="order"/>
      <NumberField source="background_order"/>
      <DateField source="updated_at" showTime/>
      <EditButton/>
    </Datagrid>
  </List>
);

export const BlockerCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect="/blockers">
      <TextInput source="title" />
      <LongTextInput source="sub_title"/>
      <TextInput source="link_name"/>
      <TextInput source="link_url"/>
      <NumberInput source="order"/>
      <NumberInput source="background_order"/>
      <SelectInput source="type" allowEmpty choices={[
        { id: 'porn', name: 'Porn Blocker' },
        { id: 'web', name: 'Web Blocker' },
      ]} />
    </SimpleForm>
  </Create>
);

const EditToolbar = props => (
  <Toolbar {...props} >
    <SaveButton/>
  </Toolbar>
);

export const BlockerEdit = (props) => (
  <Edit {...props} undoable={false}>
    <TabbedForm redirect="/blockers">
      <FormTab label="Blocker Info">
        <TextInput source="title" />
        <LongTextInput source="sub_title"/>
        <TextInput source="link_name"/>
        <TextInput source="link_url"/>
        <NumberInput source="order"/>
        <NumberInput source="background_order"/>
        <SelectInput source="type" allowEmpty choices={[
          { id: 'porn', name: 'Porn Blocker' },
          { id: 'web', name: 'Web Blocker' },
        ]} />
      </FormTab>
    </TabbedForm>
  </Edit>
);